
export enum IconType {
    CARD = 'card',
    EMAIL = 'email',
    LISTO = 'listo',
    INFO = 'info',
    SCHEDULE = 'schedule',
    ERROR = 'error',
    DELETE = 'delete',
}
